import { useQuery } from './useQuery';
import { RecentViewedProductsDocument } from '../../queries/RecentViewedProducts.gql';

// Define a key to use in localStorage
const RECENTLY_VIEWED_PRODUCTS_KEY = 'recentlyViewedProducts';

type localViewedProduct = {
 sku: string | null | undefined,
 id: number | null | undefined,
 viewedAt: number
}

const getItemsFromLocalStorage = ():localViewedProduct[] => {
    if (typeof window !== 'undefined') { // Ensure we're in the browser
        const storedProducts = localStorage.getItem(RECENTLY_VIEWED_PRODUCTS_KEY);
        if (storedProducts) {
            const storedProductsList = JSON.parse(storedProducts)

            const sortedProducts = storedProductsList.sort((a:localViewedProduct, b:localViewedProduct) => {
                if(a.viewedAt > b.viewedAt){
                    return -1;
                }
                return 1;
            });

            return sortedProducts
        }
    }

    return []
}

export const useRecentViewedProducts = () => {

    const items: localViewedProduct[] = getItemsFromLocalStorage();
    const skuList = items.map((item) => {return item.sku});

    const { data } = useQuery(RecentViewedProductsDocument, {
        variables: {
          skuList: skuList,
        },
        fetchPolicy: 'no-cache',
    })

    const recentViewedProductsitems = data ? data.recentViewedProducts?.items : [];
    const recentViewedProducts = []
    
    // sort product
    skuList.forEach((sku) => {
        recentViewedProductsitems?.forEach((product) => {
            if(sku == product?.sku){
                // @ts-ignore
                recentViewedProducts.push(product);
                return false;
            }
        })
    })

    // Function to add a product to the recently viewed list
    const addProductToRecentViewed = (product: Product) => {
        const prevProducts = getItemsFromLocalStorage();
        const localProduct:localViewedProduct = {sku: product.sku, id: product.id, viewedAt: Date.now()}
        const updatedProducts = [localProduct, ...prevProducts.filter(p => p.id !== product.id)]; // Avoid duplicates
        const trimmedProducts = updatedProducts.slice(0, 8); // Limit to 8 products
        
        localStorage.setItem(RECENTLY_VIEWED_PRODUCTS_KEY, JSON.stringify(trimmedProducts));
        return trimmedProducts;
    };

    return {
        recentViewedProducts,
        addProductToRecentViewed
    };
};